import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/student/donorscreen/DonorTeam.css';

const DonorTeamSection = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Rebecca Johnson',
      role: 'Executive Director',
      image: 'https://i.pinimg.com/736x/82/15/6e/82156efb97036511e62c4e3156e823da.jpg',
      alt: 'Rebecca Johnson - Executive Director'
    },
    {
      id: 2,
      name: 'Samuel Lee',
      role: 'Program Manager',
      image: 'https://i.pinimg.com/1200x/9d/f4/b8/9df4b87d1010a38a19a0234f99235029.jpg',
      alt: 'Samuel Lee - Program Manager'
    },
    {
      id: 3,
      name: 'Maria Hernandez',
      role: 'Volunteer Coordinator',
      image: 'https://i.pinimg.com/736x/37/b9/0c/37b90cb76c2ddb7fc26a22a6d739d1aa.jpg',
      alt: 'Maria Hernandez - Volunteer Coordinator'
    },
    {
      id: 4,
      name: 'David Carter',
      role: 'Outreach Leader',
      image: 'https://i.pinimg.com/1200x/52/09/f6/5209f6863f1e5a4e552bdbbc30bf20fb.jpg',
      alt: 'David Carter - Outreach Leader'
    }
  ];

  return (
    <section className="donor-team">
      <Container fluid="xl">

        {/* ── Top Content Row ── */}
        <Row className="donor-team__header-row align-items-start">

          {/* Left: Main Heading */}
          <Col xs={12} md={6} className="donor-team__heading-col">
            <h1 className="donor-team__main-heading">
              Support hope with your gifts.{' '}
              <span className="donor-team__heading-muted">
                Uplifting lives through donations daily to bring
              </span>{' '}
              faith and care to all
            </h1>
          </Col>

          {/* Right: Description */}
          <Col xs={12} md={6} className="donor-team__desc-col">
            <p className="donor-team__description">
              Donation works to bring hope through faith-driven giving, helping
              communities grow with care, support, and vital aid for all in need,
              creating stronger bonds and brighter futures.
            </p>
          </Col>

        </Row>

        {/* ── Team Cards Row ── */}
        <Row className="donor-team__cards-row g-4">
          {teamMembers.map((member) => (
            <Col
              key={member.id}
              xs={12}
              sm={6}
              lg={3}
              className="donor-team__card-col"
            >
              <div className="donor-team__card">

                {/* Image Wrapper */}
                <div className="donor-team__image-wrapper">
                  <img
                    src={member.image}
                    alt={member.alt}
                    className="donor-team__image"
                    loading="lazy"
                  />
                  {/* Hover Overlay */}
                  <div className="donor-team__overlay">
                    <span className="donor-team__overlay-text">View Profile</span>
                  </div>
                </div>

                {/* Card Info */}
                <div className="donor-team__info">
                  <h3 className="donor-team__name">{member.name}</h3>
                  <p className="donor-team__role">{member.role}</p>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default DonorTeamSection;